export default function FieldError(props: {
  error: string | null | undefined;
}) {
  if (!props.error) {
    return null;
  }

  return <div className="text-danger mt-1 small">{props.error}</div>;
}
